<script setup lang="ts">
import { fr } from '@nuxt/ui/locale'

const siteConfig = useSiteConfig()

if (useRoute().query.utm_source || useRoute().query.utm_campaign) {
  const utmSource = useCookie('utm_source', { maxAge: 60 * 60 * 24 })
  const utmCampaign = useCookie('utm_campaign', { maxAge: 60 * 60 * 24 })
  const source = useCookie('source', { maxAge: 60 * 60 * 1 })
  utmSource.value = useRoute().query.utm_source
  utmCampaign.value = useRoute().query.utm_campaign
  source.value = useRoute().query.utm_campaign
}

if (useRoute().query.apiengagement_id) {
  const gouvEngagementToken = useCookie('gouv_engagement_token', { maxAge: 60 * 60 * 1 })
  gouvEngagementToken.value = useRoute().query.apiengagement_id
}

useHead({
  link: [
    {
      rel: 'icon',
      type: 'image/png',
      href: `https://www.${useBenevoltDomain()}/assets/im/platform/${siteConfig.platform?.slug}-favicon.png`
    },
    {
      rel: 'apple-touch-icon',
      href: `https://www.${useBenevoltDomain()}/assets/im/platform/${siteConfig.platform?.slug}-appleicon.png`
    }
  ],
  meta: [
    {
      property: 'og:image',
      content: `https://www.${useBenevoltDomain()}/assets/im/platform/${siteConfig.platform?.slug}-opengraph.jpg`,
    },
    {
      property: 'og:image:width',
      content: '1200',
    },
    {
      property: 'og:image:height',
      content: '630',
    },
    {
      property: 'og:image:type',
      content: 'image/jpeg',
    },
    {
      property: 'twitter:image',
      content: `https://www.${useBenevoltDomain()}/assets/im/platform/${siteConfig.platform?.slug}-opengraph.jpg`,
    },
    {
      property: 'twitter:image:width',
      content: '1200',
    },
    {
      property: 'twitter:image:height',
      content: '630',
    },
    {
      property: 'twitter:image:type',
      content: 'image/jpeg',
    }
  ]
})

if (siteConfig.platform?.settings?.google_site_verification) {
  useHead({
    meta: [
      {
        name: 'google-site-verification',
        content: siteConfig.platform?.settings?.google_site_verification,
      }
    ]
  })
}

useSeoMeta({
  titleTemplate: (title) => {
    return title ? `${title} | %siteName` : (siteConfig.platform?.settings?.seo?.title ?? siteConfig.name)
  },
  description: siteConfig.platform?.settings?.seo?.description,
})

const themeProps = computed(() => {
  return siteConfig.platform?.settings?.componentsDefaults || {}
})

const themeUi = computed(() => {
  return siteConfig.platform?.settings?.componentsClass || {}
})

</script>

<template>
  <NuxtLoadingIndicator :color="useSiteConfig().platform?.subheader?.active ? '#ffffff' : useSiteConfig().platform?.settings?.colors?.primary" :height="2" />
  <PlatformApp>
    <UTheme :props="themeProps" :ui="themeUi">
      <UApp :locale="fr" :tooltip="{ delayDuration: 0}">
        <NuxtLayout>
          <NuxtPage />
        </NuxtLayout>
      </UApp>
    </UTheme>
  </PlatformApp>
</template>

<style>
@media (min-width: 1024px) {
  .header-with-menu {
    --ui-header-height: 112px;
  }
}
</style>